"use strict";

define('view/page.file.drop',['uikit/modules/dimmer', 'uikit/collections/container', 'uikit/elements/text', 'FileAPI'], function (Dimmer, Container, TextView, FileAPI) {
  var PageFileDrop = Dimmer.extend({
    initialize: function initialize() {
      this.inverted = true;
      this.page = true;
      this.centered = true;
      this.content = new Container({
        className: 'ui inverted icon header huge'
      });
      this.content.add(new TextView({
        tagName: 'i',
        className: 'icon cloud upload'
      })).add(new TextView({
        text: 'Drop Files to Add'
      }));
      this.once('render', this._setupDND, this);
    },
    _setupDND: function _setupDND() {
      var gotFileDrop = false,
        lastHoverValue = false,
        target = this.getOptions('target') || document.body,
        dimmer = this;
      FileAPI.event.dnd(target, onHover, onDrop);
      this.on('destroy', function () {
        FileAPI.event.dnd.off(target, onHover, onDrop);
      });
      function onHover(over) {
        if (dimmer.dropEnabled && over !== lastHoverValue && !gotFileDrop) {
          lastHoverValue = over;
          showDimmer(over);
        }
      }
      ;
      function onDrop(files) {
        gotFileDrop = true;
        showDimmer(false);
        setTimeout(function () {
          gotFileDrop = false;
        }, 500);
        var filesAsArray = [];
        if (files && files.length > 0) {
          FileAPI.each(files, function (file) {
            dimmer.trigger('file', file);
            filesAsArray.push(file);
          });
          dimmer.trigger('files', filesAsArray);
        }
      }
      ;
      function showDimmer(over) {
        if (!dimmer._isShown) {
          dimmer.$el.appendTo(document.body);
          dimmer.triggerMethod('show');
        }
        dimmer.active = !!over;
      }
      ;
    }
  });
  return PageFileDrop;
});

